export default __webpack_public_path__ + "static/tranquilite-40f7f2545b1db5a7b8b61295d029b24c.png";